import { render, staticRenderFns } from "./ProgsocCollectiveExportModal.vue?vue&type=template&id=f46d72be"
import script from "./ProgsocCollectiveExportModal.vue?vue&type=script&lang=js"
export * from "./ProgsocCollectiveExportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports